module.exports = __webpack_public_path__ + "img/fire.ed9d52a9.svg";